import React from 'react';

export default function IcSetaDown() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="7" viewBox="0 0 13 7">
	<path d="M12,0.5c0,0.1,0,0.3-0.1,0.4L6.5,6.4C6.4,6.5,6.2,6.6,6.1,6.6c0,0,0,0,0,0C6,6.6,5.8,6.5,5.8,6.4L0.2,1C0.1,1,0,0.8,0,0.7
		c0-0.1,0-0.3,0.1-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.2,0,0.3,0.1,0.4,0.2l5.2,5l5.1-5.2C11.2,0.1,11.4,0,11.5,0s0.3,0,0.4,0.1
		C11.9,0.2,12,0.3,12,0.5z"/>
    </svg>
  );
}
